import { useState, useRef, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Hidden,
  Avatar,
  Box,
  Popper,
  Grow,
  Paper,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { navLinkClasses } from "src/assets/styles/navigation";
import { useAppContext } from "src/context/AppContext";
import DrawerList from "./DrawerList";
import user_ava from "src/assets/img/user_def.png";
import newlogo from "src/assets/img/newlogo.png";
import extensiondownload from "src/assets/img/extensiondownload.png";
import questionnaire from "src/assets/img/questionnaire.png";
import logosmall from "src/assets/img/logosmall.png";
import toast from "src/assets/img/toast.png";
import closetoast from "src/assets/img/closetoast.png";
import hovericon from "src/assets/img/hovericon.png";
import card from "src/assets/img/card.png";
import loginicon from "src/assets/img/loginicon.png";

const useStyles = makeStyles((theme) => {
  return {
    appBar: {
      backgroundColor: "#fff",
      maxWidth: "100%",
      "& .MuiToolbar-root": {
        width: "100%",
      },
      "& .active": {
        // borderBottom: `2px solid ${theme.palette.primary.main} !important`,
        textDecoration: "none !important",
        fontWeight: 500,
        color: "#F54E51 !important",
      },
    },
    logo: {
      display: "flex",
      flexGrow: 1,

      "& img": {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
      },
    },
    avatar: {
      // cursor: "pointer",
      // margin: "0 16px",
      // boxShadow: "0px 0px 3px 1px rgba(34, 60, 80, 0.1)",
      width: "20px",
      height: "20px",
    },
    popperShiftLeft: {
      transform: "translateX(-30px) !important", // 往左 30px
    },
    tooltip: {
      backgroundColor: "#F7F8FA",
    },
    ...navLinkClasses(theme),
  };
});

export default function Nav() {
  const classes = useStyles();
  const DOWNLOAD_TOAST_KEY = "hasSeenExtensionToast";

  const { isAuthenticated, logout, userInfo } = useAppContext();

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const anchorRef = useRef(null);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 150);
  };

  const handleToastColse = () => {
    setToastOpen(false);
  };

  const handleExtension = () => {
    window.open(
      "https://chromewebstore.google.com/detail/cashback-linx/bgfbfjgpimjimknkkiilblmeeeaofglj"
    );
    handleToastColse();
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    const link = event.target?.dataset?.link;
    if (!!link) navigate(link);
    setOpen(false);
  };

  const logOutHandler = () => {
    logout();
    setOpen(false);
    navigate("/login");
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // 页面加载时检查 localStorage
    const hasSeen = localStorage.getItem(DOWNLOAD_TOAST_KEY);

    if (!hasSeen) {
      // 第一次访问 → 显示 toast，并标记已看过
      setToastOpen(true);
      localStorage.setItem(DOWNLOAD_TOAST_KEY, "true");
    }
  }, []);

  return (
    <AppBar
      position="static"
      elevation={1}
      color="default"
      className={classes.appBar}
    >
      <Toolbar>
        <Box className={classes.logo}>
          <Box
            display="flex"
            alignItems="center"
            width={{ xs: 40, sm: 130 }}
            mr={4}
          >
            <Link to={"/"}>
              <Box component="picture">
                <source media="(max-width: 600px)" srcSet={logosmall} />
                <img src={newlogo} alt="Cashback Links" />
              </Box>
            </Link>
          </Box>
          {isAuthenticated && (
            <Hidden mdDown>
              <NavLink className={classes.navLink} to="/">
                Generator
              </NavLink>
              <NavLink
                className={classes.navLink}
                to="/account/cashback-history"
              >
                Cashback History
              </NavLink>
              {/* <NavLink className={classes.navLink} to="/account/link-history">
                Short Link History
              </NavLink> */}
              <NavLink className={classes.navLink} to="/account/shopping-trips">
                Shopping Trips
              </NavLink>
              <NavLink
                className={classes.navLink}
                to="/price-alert/my-price-alert"
              >
                Price Alert
              </NavLink>
              <NavLink
                className={classes.navLink}
                to="/amazon-bestbuy-walmart-top-deals"
              >
                Top Deals
              </NavLink>
            </Hidden>
          )}
        </Box>

        {/* <Hidden mdDown>
          <Box sx={{ position: "relative" }}>
            <Box
              onClick={handleExtension}
              onMouseEnter={handleToastColse}
              sx={{
                cursor: "pointer",
                pointerEvents: "auto",
                mr: "32px",
                mt: "8px",
                "& img": {
                  cursor: "pointer",
                  pointerEvents: "auto",
                },
              }}
            >
              <img
                src={extensiondownload}
                alt="extension"
                style={{ width: 146, height: 32 }}
              />
            </Box>

            {toastOpen && (
              <Box sx={{ position: "absolute", top: "70px", left: "-30px" }}>
                <img
                  src={toast}
                  alt="toast"
                  style={{
                    width: "14px",
                    height: "14px",
                    position: "absolute",
                    top: "-12px",
                    left: "60px",
                  }}
                />
                <Box
                  sx={{
                    bgcolor: "#1D2129",
                    width: "287px",
                    height: "64px",
                    p: "12px",
                    pt: "8px",
                    fontWeight: "500",
                    color: "#ffffff",
                    fontSize: "16px",
                    borderRadius: "6px",
                    display: "flex",
                  }}
                >
                  Download CBL extension to efficiently generate short links
                  <img
                    onClick={handleToastColse}
                    src={closetoast}
                    alt="closetoast"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginTop: "4px",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Hidden> */}

        {/* <Hidden mdDown>
          <Link to={"/extension-download"}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              style={{
                width: "216px",
                height: "28px",
                color: "#FFF",
                backgroundColor: "#F54E51",
                borderRadius: "33px",
                fontWeight: "500",
                marginRight: "32px",
                cursor: "pointer",
              }}
            >
              <img
                style={{ width: "146px", height: "px", marginRight: "4px" }}
                src={extensiondownload}
                alt="Cashback Links"
              />
            </Box>
          </Link>
          
        </Hidden> */}

        {!isAuthenticated ? (
          <>
            <Hidden mdDown>
              <Box className={classes.authBtn}>
                {/* <NavLink to="/auth/sign-up">
                  Sign Up
                </NavLink>
                <Divider
                  orientation="vertical"
                  flexItem
                  light
                  style={{ marginLeft: 5, marginRight: 5 }}
                /> */}
                <NavLink to="/login">Sign in</NavLink>
              </Box>
            </Hidden>
          </>
        ) : (
          <Hidden mdDown>
            <Box
              ref={anchorRef}
              display="flex"
              alignItems="center"
              sx={{
                bgcolor: "#1D2129",
                borderRadius: "31px",
                width: "110px",
                height: "28px",
                pl: "4px",
                pr: "8px",
                cursor: "pointer",
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Avatar
                alt={userInfo?.email}
                src={userInfo?.avatar || user_ava}
                className={classes.avatar}
              />
              <Typography
                style={{
                  fontSize: "14px",
                  color: "#fff",
                  width: "46px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  marginLeft: "8px",
                  marginRight: "8px",
                }}
              >
                {userInfo.email}
              </Typography>
              <img src={hovericon} alt="" style={{ width: 16, height: 16 }} />
            </Box>

            {/* 完全自定义的悬浮卡片 */}
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              placement="bottom-end"
              transition
              style={{ zIndex: 1300 }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {({ TransitionProps }) => (
                <Grow {...TransitionProps}>
                  <Paper
                    sx={{
                      transform: "translateX(-130px)", // 关键：往左移 130px
                    }}
                  >
                    {/* 你的内容 */}
                    <Box
                      sx={{
                        width: "393px",
                        height: "248px",
                        marginTop: "18px",
                        borderRadius: "12px",
                        bgcolor: "#F7F8FA",
                        p: "12px",
                      }}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ p: "12px" }}
                      >
                        <Box>
                          <Typography
                            style={{ fontSize: "12px", color: "#86909C" }}
                          >
                            Account Balance
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "20px",
                              color: "#1D2129",
                              fontWeight: "700",
                              marginTop: "8px",
                            }}
                          >
                            $
                            {userInfo?.cashbacklinx?.pending
                              ? (
                                  userInfo.cashbacklinx.balance +
                                  userInfo.cashbacklinx.pending
                                ).toFixed(2)
                              : 0}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            style={{ fontSize: "12px", color: "#86909C" }}
                          >
                            Available
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "20px",
                              color: "#1D2129",
                              fontWeight: "700",
                              marginTop: "8px",
                            }}
                          >
                            $
                            {userInfo?.cashbacklinx?.balance
                              ? userInfo.cashbacklinx.balance.toFixed(2)
                              : 0}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            style={{ fontSize: "12px", color: "#86909C" }}
                          >
                            Pending
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "20px",
                              color: "#1D2129",
                              fontWeight: "700",
                              marginTop: "8px",
                            }}
                          >
                            $
                            {userInfo?.cashbacklinx?.pending
                              ? userInfo.cashbacklinx.pending.toFixed(2)
                              : 0}
                          </Typography>
                        </Box>
                      </Box>

                      <Link to={"/support"}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            p: "12px",
                            cursor: "pointer",
                            "&:hover": {
                              bgcolor: "#0029FF",
                            },
                          }}
                          className="tooptip"
                        >
                          <Typography
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#1D2129",
                            }}
                          >
                            Support
                          </Typography>
                          <img
                            src={questionnaire}
                            alt=""
                            style={{ width: 16, height: 16 }}
                          />
                        </Box>
                      </Link>

                      <Link to={"/privacy"}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            p: "12px",
                            cursor: "pointer",
                            "&:hover": {
                              bgcolor: "#0029FF",
                            },
                          }}
                          className="tooptip"
                        >
                          <Typography
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#1D2129",
                            }}
                          >
                            Privacy Policy
                          </Typography>
                          <img
                            src={card}
                            alt=""
                            style={{ width: 16, height: 16 }}
                          />
                        </Box>
                      </Link>

                      <Box
                        onClick={logOutHandler}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        className="tooptip"
                        sx={{ p: "12px", cursor: "pointer" }}
                      >
                        <Typography
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#F54E51",
                          }}
                        >
                          Log Out
                        </Typography>
                        <img
                          src={loginicon}
                          alt=""
                          style={{ width: 16, height: 16 }}
                        />
                      </Box>
                    </Box>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Hidden>
        )}
        <DrawerList />
      </Toolbar>
    </AppBar>
  );
}
